import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../../contexts/CartProvider';
import styles from './style.module.scss';
import { MdShoppingCart, MdArrowBack } from 'react-icons/md';
import { FiShoppingBag } from 'react-icons/fi';
import StepCarrinho from '../../Components/StepCarrinho';
import { Link } from 'react-router-dom';
import LabelStepsCarrinho from '../../Components/LabelStepsCarrinho';
import StepMinhConta from '../../Components/StepMinhConta';
import { useAuth } from '../../contexts/AuthContext';
import StepPagamento from '../../Components/StepPagamento';
import CompraConcluida from '../../Components/CompraConcluida';

const Carrinho = ({ onResetStep }) => {
  const { items, clearCoupon } = useCart();
  const [step, setStep] = useState(0);
  const [idPagamento, setIdPagamento] = useState(0);
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isCartEmpty = items.length === 0;
  const cartCountLabel = `${items.length} ${items.length === 1 ? 'item' : 'itens'} no carrinho`;
  const hasSaldoItem = items.some((item) => item.nome === 'Saldo');
  const saldoValue = items.find((item) => item.nome === 'Saldo')?.valor;

  useEffect(() => {
    clearCoupon();
    const params = new URLSearchParams(location.search);
    const stepParam = params.get('step');
    if (stepParam === 'pagamento') {
      setStep(2);
    } else {
      setStep(0);
    }
  }, [location.search, clearCoupon]);

  const syncStepQueryParam = useCallback((value) => {
    const currentUrl = new URL(window.location);

    if (value) {
      currentUrl.searchParams.set('step', value);
    } else {
      currentUrl.searchParams.delete('step');
    }

    window.history.replaceState({}, '', currentUrl);
  }, []);

  const handleNextStep = (idPagamentoConcluido) => {
    console.log('idPagamentoConcluido', idPagamentoConcluido);

    if (hasSaldoItem) {
      navigate(`/saldo?saldoInserir=${saldoValue}`);
      return;
    }

    if (step === 0 && user) {
      syncStepQueryParam('pagamento');
      setStep(2);
      return;
    }

    const stepParam = new URLSearchParams(location.search).get('step');
    if (stepParam !== 'pagamento' && step === 2) {
      setStep(0);
      return;
    }

    const nextStep = step + 1;

    if (idPagamentoConcluido && nextStep === 3) {
      setIdPagamento(idPagamentoConcluido);
    }

    setStep(nextStep);
  };

  const resetStep = useCallback(() => {
    setStep(0);
    syncStepQueryParam(null);
  }, [syncStepQueryParam]);

  useEffect(() => {
    if (onResetStep) {
      onResetStep(resetStep);
    }
  }, [onResetStep, resetStep]);

  const onChangeStep = (value) => {
    setStep(value);
  };

  const getStepTitle = () => {
    switch (step) {
      case 0: return 'Seu Carrinho';
      case 1: return 'Minha Conta';
      case 2: return 'Pagamento';
      case 3: return 'Compra Concluída';
      default: return 'Carrinho';
    }
  };

  const renderStepContent = () => {
    if (step === 0) {
      return <StepCarrinho items={items} handleNextStep={handleNextStep} />;
    }

    if (step === 1) {
      return <StepMinhConta items={items} handleNextStep={handleNextStep} />;
    }

    if (step === 2) {
      return (
        <StepPagamento
          items={items}
          handleNextStep={(idPagamento) => handleNextStep(idPagamento)}
        />
      );
    }

    return <CompraConcluida items={items} idPagamento={idPagamento} />;
  };

  return (
    <div className={styles.container}>
      {!isCartEmpty ? (
        <div className={styles.containerCarrinho}>
          {/* Header do Carrinho */}
          <div className={styles.cartHeader}>
            <div className={styles.headerContent}>
              <button 
                className={styles.backButton}
                onClick={() => navigate('/')}
              >
                <MdArrowBack />
              </button>
              <div className={styles.headerInfo}>
                <h1 className={styles.cartTitle}>{getStepTitle()}</h1>
                <p className={styles.cartSubtitle}>{cartCountLabel}</p>
              </div>
              <div className={styles.cartIcon}>
                <FiShoppingBag />
                <span className={styles.itemCount}>{items.length}</span>
              </div>
            </div>
          </div>

          {/* Steps Navigation */}
          <LabelStepsCarrinho 
            onChangeStep={onChangeStep} 
            step={step} 
            labelConta={!user} 
          />

          {/* Step Content */}
          <div className={styles.stepContent}>
            {renderStepContent()}
          </div>
        </div>
      ) : (
        <div className={styles.containerVazio}>
          <div className={styles.emptyCartIcon}>
            <MdShoppingCart />
          </div>
          <h2 className={styles.emptyTitle}>Seu carrinho está vazio</h2>
          <p className={styles.emptySubtitle}>
            Que tal dar uma olhada nos nossos bolões disponíveis?
          </p>
          <Link to='/' className={styles.continueShoppingLink}>
            <button className={styles.continueShoppingButton}>
              <FiShoppingBag />
              <span>Continuar Comprando</span>
            </button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default Carrinho;
